import DataStudioService from 'src/modules/dataStudio/dataStudioService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'DATASTUDIO_VIEW';

const dataStudioViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: dataStudioViewActions.FIND_STARTED,
      });

      const record = await DataStudioService.find(id);

      dispatch({
        type: dataStudioViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: dataStudioViewActions.FIND_ERROR,
      });

      getHistory().push('/data-studio');
    }
  },
};

export default dataStudioViewActions;
